<template><div class="mc-wrapper"><div class="mc-container"><h1>Образы</h1></div></div></template>
<script>
export default {name: 'LookbooksView'}
</script>
